var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['authUser/getPermissions'].includes('TOUCH_INTERFACE_ACCESS'))?_c('navbar-button-template',{attrs:{"emit-click":false}},[_c('router-link',{attrs:{"to":{ name: 'touchInterface.index' }}},[_c('fa-icon',{attrs:{"fixed-width":"","icon":"pallet"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }